import { render, staticRenderFns } from "./eComplaintLogs.vue?vue&type=template&id=94874880"
import script from "./eComplaintLogs.vue?vue&type=script&lang=js"
export * from "./eComplaintLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports